
import { Link } from "react-router-dom";
import React from 'react';

export default function DynamicSolutions({ data, extraClass = "" }) {
    if (!data) return null;
    
  return (
    <>
      <div className={`smart-solutions ${extraClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-10 col-lg-5">
              <div className="solutions-content">
                <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.section5_heading }} />
                <p>{data?.section5_description}</p>
                <div className="smart-btn">
                  <Link to={"/about"} className="default-btn"> <span>Learn More</span>  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-6 ">
            </div>
          </div>
        </div>
      </div>
    </>
  )
}



